export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    PleatedBlinds: 1,
    AftCabinLayout: 1,
    FabricCabins: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'AftCabinLayout',
      dependency: 'Veneer'
    },
    {
      option: 'FabricCabins',
      dependency: 'AftCabinLayout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/aftcabin.js